import {
  EmailTemplate,
  EmailTemplateType,
  UpsertEmailTemplateRequest,
} from '@interfaces/templates.interface';

import api from './';

export const { useGetEmailTemplateQuery, useUpsertEmailTemplateMutation } =
  api.injectEndpoints({
    endpoints: (build) => ({
      getEmailTemplate: build.query<EmailTemplate, EmailTemplateType>({
        query: (type) => ({ url: `templates/${type}` }),
        providesTags: ['templates'],
      }),
      upsertEmailTemplate: build.mutation<
        EmailTemplate,
        UpsertEmailTemplateRequest
      >({
        query: ({ type, body }) => ({
          url: `templates/${type}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['templates'],
      }),
    }),
  });
